'use client';

import { useRouter } from 'next/navigation';
import { usePathHistory } from './providers/StoreRouterPathProvider';

export function BackButtonSkeleton({
  defaultHref = '..',
  className,
  children,
}: {
  // The default href to go back to if the browser history is empty
  defaultHref?: string;
  className?: string;
  children: React.ReactNode;
}) {
  const { back, push } = useRouter();
  const { prevPath } = usePathHistory();

  return (
    <button
      className={className}
      onClick={() => {
        if (window.history.length > 1 && prevPath) {
          back();
        } else {
          push(defaultHref);
        }
      }}
    >
      {children}
    </button>
  );
}
